<template>
  <div class="assessor-link d-flex justify-content-start">
    <a v-if="!!property"
      :href="safeHref(property.url)"
       target="_blank"
       title="Open the assessor record in a new tab"
       class="d-flex flex-row align-items-center gap-1"
     rel="noopener noreferrer">
      <div>Parcel {{ property.id }}</div>
      <i v-if="useEndIcon" class="bi-box-arrow-up-right small" style="font-size:0.8em" />
    </a>
    <div v-else class="text-muted small">
      (Unverified Address)
    </div>
  </div>
</template>

<script>
import { safeHref } from '@/safeRendering';
import {Property} from "@/models/Property";

export default {
  methods: {
    safeHref
  },
  props: {
    property: Property,
    useEndIcon: Boolean
  }
}
</script>

<style>
.assessor-link > a {
  text-decoration: none;
  color: inherit;
}
.assessor-link > a:hover {
  text-decoration: underline;
}
</style>
